import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  getDates,
  nbfCustomerAccount,
  nbfCustomers,
  nbfGetDepartments,
  nbfInventory,
  nbfProduct,
  nbfRawMetarial,
  nbfUsers,
  nbfgetPurchaseDates,
} from "../api/restApi";
import { updateAllLevels } from "../store/action";
import { setCustomers } from "../store/reducer/customersSlice";
import { setDepartments } from "../store/reducer/departmentsSlice";
import { setInventory } from "../store/reducer/inventorySlice";
import { setPurchaseDate } from "../store/reducer/orderPurchaseDate";
import { setOrdersDate } from "../store/reducer/ordersSlice";
import { setPayment } from "../store/reducer/paymentSlice";
import { setProducts } from "../store/reducer/productsSlice";
import { setRawItems } from "../store/reducer/rawItemsSlice";
import { setUsers } from "../store/reducer/usersSlice";
import { useAppDispatch } from "../utils/hooks";


export default function Home() {
  const dispatch = useAppDispatch();
  const role = useSelector((state) => state.currentUser.roleAllowed);

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      // callData();
    }

    return () => (mounted = false);
  }, []);

  //  Accounts
  // This updateAllLevels will get accounts data from firebase and store them into redux store
  useEffect(() => {
    loadBasicData();
    if (role.isOrdering) {
      loadOrderingData();
    }
    if (role.isInventory) {
      loadInventoryData();
    }
    if (role.isAccounting) {
      loadAccountingData();
    }

    if (role.isSupervisor) {
      loadSupervisorData();
    }
    if (role.isCEO) {
      loadCEOData();
    }
  }, [role]);

  async function loadBasicData() {
    let customers = await nbfCustomers();
    dispatch(setCustomers(customers));
    let product = await nbfProduct();
    dispatch(setProducts(product));
    let rawItems = await nbfRawMetarial();
    dispatch(setRawItems(rawItems));
    let departments = await nbfGetDepartments();
    dispatch(setDepartments(departments));
    let inventory = await nbfInventory();
    inventory = inventory.map((pro) => {
      return {
        ...pro,
        ...product.find((el) => el.id.toString() === pro.id.toString()),
      };
    });
    dispatch(setInventory(inventory));

    let datesofOrders = await getDates();
    dispatch(setOrdersDate(datesofOrders));
  }
  async function loadOrderingData() {}
  async function loadInventoryData() {
    let datesofPurchaseOrders = await nbfgetPurchaseDates();
    dispatch(setPurchaseDate(datesofPurchaseOrders));
  }

  async function loadAccountingData() {
    let customerAcccount = await nbfCustomerAccount();
    dispatch(setPayment(customerAcccount));
    updateAllLevels(dispatch);
  }
  async function loadSupervisorData() {
    let users = await nbfUsers();
    dispatch(setUsers(users));
  }
  async function loadCEOData() {}

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        height: "80vh",
      }}
    >
      <div style={{ display: "flex", justifyContent: "center" }}>
        {/* <img
          src={require("../assets/Images/logo.png")}
          width={120}
          height={120}
          alt="no logo"
        /> */}
      </div>
      <div style={{ textAlign: "center", marginTop: 10 }}>
        <text style={{ fontSize: 25, fontWeight: "bolder", color: "#FAA832" }}>
          National Bake Factory
        </text>
      </div>
    </div>
  );
}
